"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MyTaxes;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_1 = require("react-native");
const Screen_1 = __importDefault(require("../components/Screen"));
const Theme_1 = require("../Theme");
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const TaxDocumentsCard_1 = __importDefault(require("../partials/TaxDocumentsCard"));
const StateWithholdingCard_1 = __importDefault(require("../partials/StateWithholdingCard"));
const FederalWithholdingCard_1 = __importDefault(require("../partials/FederalWithholdingCard"));
const UserContext_1 = require("../contexts/UserContext");
const Taxes_1 = __importDefault(require("../api/Taxes"));
const TaxDocumentDeliveryMethodCard_1 = __importDefault(require("../partials/TaxDocumentDeliveryMethodCard"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function MyTaxes(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [taxSummary, setTaxSummary] = react_1.default.useState(null);
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const hasLoadedSummaryRef = react_1.default.useRef(false);
    const didInitialLoadRef = react_1.default.useRef(false);
    const [w2Electronic, setW2Electronic] = react_1.default.useState(false);
    const [form1095Electronic, setForm1095Electronic] = react_1.default.useState(false);
    const [deliveryLoaded, setDeliveryLoaded] = react_1.default.useState(false);
    const bothElectronic = w2Electronic && form1095Electronic;
    const [status, setStatus] = react_1.default.useState("loading");
    const cards = ['TaxDocumentsSection', 'WithholdingSection'];
    const renderWithholdingSection = () => {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FederalWithholdingCard_1.default, { status: status, federalTaxes: taxSummary?.federalTaxSummary, navigation: props.navigation, onUpdated: handleTaxSummaryUpdated }, "FederalWithholding"), taxSummary?.stateTaxSummaries?.length > 0 ? ((0, jsx_runtime_1.jsx)(StateWithholdingCard_1.default, { status: status, stateTaxes: taxSummary?.stateTaxSummaries, navigation: props.navigation, onUpdated: handleTaxSummaryUpdated }, "StateWithholding")) : null] }));
    };
    const renderTaxDocumentDeliveryMethodCard = () => ((0, jsx_runtime_1.jsx)(TaxDocumentDeliveryMethodCard_1.default, { w2Electronic: w2Electronic, form1095Electronic: form1095Electronic, onChange: (state) => {
            setW2Electronic(state.w2Electronic);
            setForm1095Electronic(state.form1095Electronic);
        } }, "TaxDocumentDeliveryMethodCard"));
    const renderTaxDocumentsSection = () => {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [deliveryLoaded && !bothElectronic && renderTaxDocumentDeliveryMethodCard(), (0, jsx_runtime_1.jsx)(TaxDocumentsCard_1.default, { navigation: props.navigation }, "TaxDocuments"), deliveryLoaded && bothElectronic && renderTaxDocumentDeliveryMethodCard()] }));
    };
    const renderCard = ({ item }) => {
        switch (item) {
            case 'TaxDocumentsSection':
                return renderTaxDocumentsSection();
            case 'WithholdingSection':
                return renderWithholdingSection();
            default:
                return null;
        }
    };
    const refresh = react_1.default.useCallback(async ({ showLoading = false } = {}) => {
        promise.current?.cancel();
        if (showLoading || !hasLoadedSummaryRef.current) {
            setStatus("loading");
        }
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(async (token) => {
            const [summary, w2, form1095] = await Promise.all([
                Taxes_1.default.getTaxesSummary(token),
                Taxes_1.default.getW2Election(token),
                Taxes_1.default.get1095CElection(token),
            ]);
            setTaxSummary(summary);
            setW2Electronic(w2);
            setForm1095Electronic(form1095);
            setDeliveryLoaded(true);
            hasLoadedSummaryRef.current = true;
            setStatus("done");
        }).catch((e) => {
            setStatus("error");
            console.error(e);
        }));
        await promise.current;
    }, [userContext]);
    const handleTaxSummaryUpdated = react_1.default.useCallback(() => {
        refresh();
    }, [refresh]);
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh({ showLoading: true }).finally(() => {
            setRefreshing(false);
        });
        return () => promise.current?.cancel();
    }, [refresh]);
    react_1.default.useEffect(() => {
        if (didInitialLoadRef.current)
            return;
        didInitialLoadRef.current = true;
        refresh({ showLoading: true });
        return () => promise.current?.cancel();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { marginVertical: 6, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.TaxesBackgroundWeb : Theme_1.IMAGES.TaxesBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }) }), (0, jsx_runtime_1.jsx)(MasonryList_1.default, { data: cards, keyExtractor: (item) => item, renderItem: renderCard })] }));
}
;
